// Brand logo presentation helpers.
//
// The catalog UI is dark-themed, so logo tiles are LIGHT by default —
// the standard "logo plate" treatment that keeps dark and coloured
// wordmarks legible. A handful of vendors only publish their wordmark
// in white (intended for their own dark websites); those get a dark
// tile instead. Keyed by the logo filename slug (logo_url basename
// without extension).

// Measured per asset 2026-10-21 (pixel brightness for PNGs, fill colors
// for SVGs): these logo FILES are white/light content and vanish on a
// white plate. A few vendors have dark standard logos — but the asset
// we ship is their white variant (e.g. sony.svg is #ffffff-only).
const DARK_TILE_BRAND_SLUGS = new Set([
  "adeo",
  "ati",
  "audiocom",
  "cinephil",
  "dreamscreen",
  "grand-film-chair",
  "home-cinema-module",
  "integra",
  "madvr",
  "mag-audio-theatron",
  "magnetar",
  "middle-atlantic",
  "powergrip",
  "powersoft",
  "projecta",
  "r-volution",
  "reavon",
  "shorelivings",
  "sony",
  "trinnov",
  "zappiti",
]);

export function brandLogoSlug(logoUrl: string | null | undefined): string {
  if (!logoUrl) return "";
  const base = logoUrl.split("?")[0]?.split("/").pop() ?? "";
  return base.replace(/\.(svg|png|jpe?g|webp|gif)$/i, "");
}

/** Tailwind classes for the brand-logo tile: light plate by default,
 *  dark when the vendor's only published wordmark is white. */
export function brandLogoTileClass(logoUrl: string | null | undefined): string {
  const base =
    "flex h-12 w-20 shrink-0 items-center justify-center overflow-hidden rounded-md border border-border";
  return DARK_TILE_BRAND_SLUGS.has(brandLogoSlug(logoUrl))
    ? `${base} bg-[#1c2536]`
    : `${base} bg-white`;
}

/** Deep link to the catalog filtered to one brand — the admin brand
 *  directory uses it so a row opens that brand's products instead of
 *  only showing a count. encodeURIComponent covers accented and
 *  spaced names (Adéo, Ciné Paint white). */
export function brandCatalogHref(brandName: string): string {
  return `/catalog?brand=${encodeURIComponent(brandName)}`;
}
